import { setConfig } from "@justhome/common";

export const isProd = process.env.VERCEL_ENV === "production";

setConfig({
  api: {
    core: {
      baseUrl: process.env.PUBLIC_CORE_API_HOST,
    },
  },
  logger: {
    service: "calculator",
    version: process.env.PUBLIC_RELEASE_VERSION,
  },
});
